import { SearchSortField, SearchSortDirection, BillingPeriod, SymetraDateTime } from '@benefitsui/app/api/benefits-clients';

export const Constants = {
  AmountKey: 'amount',
  AmountText: 'Amount',
  BillGroupKey: 'billGroup',
  BillGroupText: 'Bill group',
  CloseText: 'Close',
  CurrencyUsdKey: 'USD',
  DataKey: 'data',
  InvoiceKey: 'invoice',
  InvoicePeriodKey: 'invoicePeriod',
  InvoicePeriodAndNumberText: 'Invoice period & number',
  InvoiceText: 'Invoice',
  ListKey: 'list',
  LocaleEnglishUs: 'en-US',
  NameText: 'Name',
  PolicyIdKey: 'PolicyId',
  SortKey: 'sort',
  StatusText: 'Status',
  StringEmpty: '',
  UnspecifiedText: 'Unspecified'
};

export interface CellItemType {
  actions?: string;
  amount: number;
  amountUI: string;
  billGroupName: string;
  billGroupNumber: string;
  indicator: string;
  invoice: string;
  invoiceKey: string;
  premiumKey: string;
  dueDateKey: string;
  startDate: string;
  endDate: string;
  invoiceNumber: string;
  invoicePeriod: BillingPeriod;
  invoicePeriodString: string;
  pdfUrl?: string;
  premiumCalc?: string;
  premiumID?: string;
  runDateString: string;
  selected: boolean;
  status: string;
  xlsxUrl?: string;
  submittedBy: string;
  submittedDate: string;
  saComment: string;
}

export interface BillingData {
  totalResults: number;
  listBilling: CellItemType[];
  invoicePeriodList: string[];
}

export interface PaymentData {
  Amount: number;
  AmountUi: string;
  AmountUiError: boolean;
  BillGroupName: string;
  BillGroupNumber: string;
  Invoice: string;
  InvoiceNumber: string;
  InvoicePeriod: BillingPeriod;
  InvoiceFrom: SymetraDateTime;
}

export type BillingListSearchParameters = {
  page: number;
  pageSize: number;
  billGroupNumber: string | undefined;
  status: string | undefined;
  invoicePeriod: BillingPeriod | undefined;
  invoicePeriodString: string | undefined;
  sortField: SearchSortField;
  sortDirection: SearchSortDirection;
};

export type PaymentSearchParameters = {
  page: number;
  pageSize: number;
  sortField: SearchSortField;
  sortDirection: SearchSortDirection;
};


